import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';

function Direksi() {
    useEffect(() => {
        AOS.init({
            duration: 850,
            once: true,
        });
    }, []);

    const direksiData = [
        {
            nama: 'Randy Rachman Assegaff',
            jabatan: 'Plt. Direktur Utama',
            lokasi: 'Jakarta',
            deskripsi: 'Merupakan Warga Negara Indonesia dan saat ini berdomisili di Jakarta. Beliau merupakan lulusan Sarjana Ekonomi dari Universitas Padjadjaran pada tahun 2006.<br><br>Beliau memiliki lebih dari 13 tahun pengalaman di industri telekomunikasi dengan rekam jejak kepemimpinan dalam pengembangan bisnis, pengelolaan proyek, dan pembangunan infrastruktur telekomunikasi nasional. Sepanjang kariernya, beliau dipercaya menduduki berbagai posisi strategis, antara lain sebagai Direktur Keuangan PT Trans Nasional Teknologi, Direktur Utama PT Banda Telekomunikasi Perkasa, Direktur Business Development PT Davon Media Teknologi, Direktur Project PT Cipta Daya Selaras, serta Project Manager PT Raja Nagara Yaksa.',
            gambar: '/assets-web/photo/randy_rachman_assegaff_sqr.png',
        },
        {
            nama: 'Dirgantara Putra',
            jabatan: 'Direktur Bisnis dan Operasi',
            lokasi: 'Jakarta',
            deskripsi: 'Merupakan Warga Negara Indonesia dan saat ini berdomisili di Jakarta. Memperoleh Gelar sarjana Teknik Elektro di Institut Teknologi Bandung pada tahun 1993 dan meraih Gelar Magister Managemen di Universitas Indonesia pada tahun 2002.<br><br>Beliau memiliki pengalaman profesional yang luas di berbagai perusahaan terkemuka, termasuk menjabat sebagai Direktur Utama PT Akses Prima Indonesia, VP Business Development PT Teknologi Riset Global Investama, dan Head of Operation PT Parama Adi Mitra. Sebelumnya, beliau berkarir sebagai Head of Sales & Marketing di PT Samsung Telecommunication Indonesia serta memegang peran Customer Account Team (CAT) dan Customer Support Manager di PT Alcatel Indonesia.',
            gambar: '/assets-web/photo/dirgantara_putra_sqr.png',
        },
        {
            nama: 'Priono Joni Hartanto',
            jabatan: 'Plt. Direktur Keuangan dan SDM',
            lokasi: 'Bandung',
            deskripsi: 'Merupakan Warga Negara Indonesia dan saat ini berdomisili di Bandung. Memperoleh Gelar Sarjana Teknik Elektro di Universitas Brawijaya pada tahun 1995. <br><br>Beliau memiliki pengalaman 20 tahun berkarir di PT Len Industri (Persero), termasuk menjabat sebagai Supply Chain Management Senior General Manager, Senior GM Logistik, dan Vice President Divisi Logistik. Sebelumnya, beliau juga berperan sebagai Manager Operasi Logistik dan Manager Komersial Unit Bisnis Elektronika Pertahanan (UB. ELHAN).',
            gambar: '/assets-web/photo/priono_joni_hartono_sqr.png',
        },
    ];

    return (
        <div className="py-10 lg:py-14">
            <div className="mb-7 flex flex-col gap-2" data-aos="fade-up">
                <span className="text-xs font-semibold uppercase tracking-[0.24em] text-blue-600">
                    Kepemimpinan Perusahaan
                </span>
                <h2 className="text-3xl font-bold tracking-tight text-slate-950 sm:text-4xl">Direksi</h2>
                <p className="max-w-2xl text-justify text-sm leading-6 text-slate-500 sm:text-base">
                    Jajaran Direksi yang memimpin pengelolaan dan pengembangan bisnis perusahaan.
                </p>
            </div>

            <div className="space-y-7">
                {direksiData.map((direksi, index) => (
                    <article
                        key={direksi.nama}
                        className="overflow-hidden rounded-[28px] border border-slate-200/80 bg-white shadow-[0_20px_55px_rgba(15,23,42,0.07)] transition duration-300 hover:-translate-y-0.5 hover:shadow-[0_26px_65px_rgba(15,23,42,0.11)]"
                        data-aos="fade-up"
                        data-aos-delay={index * 70}
                    >
                        <div className="grid md:grid-cols-[250px_minmax(0,1fr)]">
                            <div className="relative overflow-hidden bg-gradient-to-br from-slate-950 via-[#0d233c] to-[#075a96] p-6">
                                <div className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full border border-white/10 bg-white/[0.04]" />
                                <div className="relative z-10 flex h-full flex-col justify-between gap-5">
                                    <span className="w-fit rounded-full border border-white/15 bg-white/10 px-3 py-1.5 text-[10px] font-semibold uppercase tracking-[0.14em] text-blue-100">
                                        {direksi.jabatan}
                                    </span>
                                    <div className="mx-auto w-full max-w-[205px] rounded-[22px] border border-white/15 bg-white/10 p-2.5 shadow-xl shadow-black/20">
                                        <Zoom>
                                            <img
                                                src={direksi.gambar}
                                                alt={direksi.nama}
                                                loading="lazy"
                                                className="aspect-[4/5] w-full cursor-zoom-in rounded-[17px] bg-white object-contain object-bottom"
                                            />
                                        </Zoom>
                                    </div>
                                    <p className="text-xs font-medium text-blue-200">Domisili {direksi.lokasi}</p>
                                </div>
                            </div>

                            <div className="p-7 sm:p-9 lg:p-10">
                                <div className="mb-5">
                                    <p className="text-xs font-semibold uppercase tracking-[0.2em] text-blue-600">Direksi</p>
                                    <h3 className="mt-1 text-2xl font-bold tracking-tight text-slate-950 sm:text-3xl">
                                        {direksi.nama}
                                    </h3>
                                    <p className="mt-1 text-sm font-semibold text-red-700 sm:text-base">{direksi.jabatan}</p>
                                </div>
                                <div className="h-px bg-gradient-to-r from-blue-600/70 via-slate-200 to-transparent" />
                                <div
                                    className="mt-6 text-justify text-[15px] leading-7 text-slate-600 [text-justify:inter-word] sm:text-base sm:leading-8"
                                    dangerouslySetInnerHTML={{ __html: direksi.deskripsi }}
                                />
                            </div>
                        </div>
                    </article>
                ))}
            </div>
        </div>
    );
}

export default Direksi;
